import styled from "@emotion/styled";


export const HomeWrapper =styled("div")`
label : HomeWrapper;
display: flex;
`